module.exports = __webpack_public_path__ + "f7afaf1e5e25a830c3a4aa4255ba57aa.jpeg";